/**
 * Utility function to close the mobile sidebar drawer from anywhere in the app.
 * 
 * This function can be called from:
 * - Browser console: window.closeSidebarDrawer()
 * - Any JavaScript code
 * - Event handlers
 * - Navigation callbacks
 * 
 * @example
 * // In browser console
 * window.closeSidebarDrawer();
 * 
 * @example
 * // In any JavaScript code
 * import { closeSidebarDrawer } from '@/utils/closeSidebarDrawer';
 * closeSidebarDrawer();
 * 
 * @example
 * // In a React component (preferred method)
 * import { useSidebarContext } from '@common/layout/sidebar/SidebarProvider';
 * const { closeMobileDrawer } = useSidebarContext();
 * closeMobileDrawer();
 */

// Store the close function globally for console access
let globalCloseFunction = null;

export const setGlobalCloseFunction = (closeFn) => {
  globalCloseFunction = closeFn;
  // Also expose to window for easy console access
  if (typeof window !== 'undefined') {
    window.closeSidebarDrawer = closeFn;
  }
};

/**
 * Close the sidebar drawer
 * Works from anywhere in the app or browser console
 */
export const closeSidebarDrawer = () => {
  if (globalCloseFunction) {
    globalCloseFunction();
  } else {
    console.warn('Sidebar drawer close function not available. Make sure SidebarProvider is mounted.');
  }
};

